import { CreateRenderFunction } from "@pdfking/reactivity/preact"

export const TaskProgress = CreateRenderFunction({
  props: {
    class: "",
    operation_perc: 0 as number,
  },
  render() {
    return (
      <div class={`d-flex align-items-center border-0 p-0 ${this.class}`}>
        {this.operation_perc > 0 && (
          <>{parseInt(String(this.operation_perc * 100), 10)}%</>
        )}
        <span class="mx-1 spinner-border spinner-border-sm" />
      </div>
    )
  },
})
